<template>
    <v-panel
        v-model="dialogShow"
        class="verifyCodePanel"
        :width="446"
        :max-height="388"
        :min-height="388"
        :mask-closable="false"
        @close="closePwdDialog"
    >
        <div class="verifyCodePanel-body">
            <div class="verifyCodePanel-body-title">
                为了企业信息安全，请验证手机号
            </div>
            <div class="verifyCodePanel-body-sub-title">
                需验证手机号以确认是否为本人， 验证通过后，1小时内无需再次验证
            </div>
            <div class="verifyCodePanel-body-phone">
                <span>手机号</span>
                <span class="verifyCodePanel-body-input">
                    {{ parsePhoneNum(verifyParams.mobile) }}
                </span>
            </div>
            <div class="verifyCodePanel-body-code">
                <span :class="inputError ? 'msg-error' : ''">验证码</span>
                <span class="error">{{ pwdError }}</span>
                <label class="verifyCodePanel-placeholder" for="glCode" />

                <v-input
                    v-model="glCode"
                    name="glcode"
                    kind="simpler"
                    :limit="6"
                    :class="inputError ? 'input-error' : ''"
                    maxlength="6"
                />
                <v-button status="default" @click="sendCode">
                    {{ sendCodeText }}
                </v-button>
            </div>
            <div class="verifyCodePanel-body-botton">
                <v-button status="primary" size="large" :class="clazz" @click="verifyCode">
                    确定
                </v-button>
                <v-button status="default" class="botton-default" size="large" @click="cancelChangePwd">
                    取消
                </v-button>
            </div>
        </div>
    </v-panel>
</template>

<script>
import Gateway from 'src/utils/Gateway';

export default {
    name: 'VerifyCodes',
    props: {
        verifyParams: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialogShow: false,
            glCode: '',
            pwdError: '',
            sendCodeText: '发送验证码',
            sendCodeSuccess: false,
            inputError: false,
            saveLoading: false,
            watchField: false,
            verifyBotton: true,
            timer: ''
        };
    },
    computed: {
        clazz() {
            const reg = /^\d+$/;
            return this.glCode.length === 6 && reg.test(this.glCode) ? '' : 'disabled';
        }
    },
    watch: {
        watchField: {
            handler() {
                this.dialogShow = false;
                this.glCode = '';
                this.pwdError = '';
                this.sendCodeText = '发送验证码';
                this.sendCodeSuccess = false;
                this.inputError = false;
                this.saveLoading = false;
                // this.watchField = false;
                this.verifyBotton = true;
                this.timer = '';
            },
            deep: true
        }
    },
    mounted() {},
    methods: {
        closePwdDialog() {
            this.watchField = !this.watchField;
        },
        sendCode() {
            if (this.sendCodeSuccess) {
                return;
            }
            Gateway.post(
                '/v1/basic/security/captcha/sendCode',
                {
                    phone_number: this.verifyParams.mobile,
                    business: 'verify_staff_actions',
                    sms_code_type: 0,
                    template: 'default'
                },
                {
                    errLevel: 1
                }
            )
                .then(res => {
                    this.sendCodeSuccess = true;
                    this.codeCountdown();
                    this.$message.success('验证码发送成功');
                    // if (res.r === 0) {
                    //     this.codeCountdown();
                    //     this.$message.success(res.msg);
                    // } else {
                    //     this.pwdError = res.msg;
                    //     this.inputError = true;
                    //     this.sendCodeSuccess = false;
                    // }
                })
                .catch(err => {
                    this.sendCodeSuccess = false;
                    this.$message.error(err.msg || '系统错误，请重试');
                });
        },
        codeCountdown() {
            const that = this;
            let wait = 60;
            const waitText = 's';
            this.sendCodeText = wait + waitText;

            that.timer = setInterval(() => {
                // eslint-disable-next-line no-plusplus
                wait--;
                if (wait < 0) {
                    clearInterval(that.timer);
                    that.sendCodeSuccess = false;
                    that.sendCodeText = '发送验证码';
                } else if (that.sendCodeSuccess) {
                    that.sendCodeText = wait + waitText;
                }
            }, 1000);

            setTimeout(() => {
                that.sendCodeSuccess = true;
            }, 0);
        },
        cancelChangePwd() {
            clearInterval(this.timer);
            this.watchField = !this.watchField;
            this.$emit('cancel');
            this.timer && clearInterval(this.timer)
        },
        verifyCode() {
            this.$emit('itemClick', this.verifyParams);
            this.$emit('passVerify', { sms_code: this.glCode, sms_mobile: this.verifyParams.mobile });
            this.watchField = !this.watchField;
            this.dialogShow = false;
            this.timer && clearInterval(this.timer)
        },

        parsePhoneNum(num) {
            const parsedNum = num && num.toString();
            const reg = /^(\d{3})(\d{4})(\d{4})$/;

            if (!parsedNum || parsedNum.length !== 11) {
                return parsedNum;
            }
            const matches = reg.exec(parsedNum);
            return `${matches[1]}****${matches[3]}`;
        }
    }
};
</script>

<style lang="less">
@import 'index.less';
</style>
